import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { ListViewModel } from '../horizontallist/listviewmodel';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { CarouselViewImpl } from './carouselview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { CarouselCSSStyleImpl } from './carouselcss';
import Swiper from 'swiper';

export interface CarouselComponentProps<T> extends UIComponentProps
{
    slidePerview: number;
    isIndicatorRequired: boolean;
    listViewModel: ListViewModel<T>;
    carouselType: CarouselType;
    id: string;
}

export enum CarouselType
{
    BANNER, CATEGORIES
}

export class CarouselComponent<T, S extends UIComponentState> extends UIComponentImpl<CarouselComponentProps<T>,S, UIDataModel> 
{
    componentDidMount()
    {
          new Swiper('.'+ this.props.id, {
                spaceBetween: 10,
                grabCursor: true,
                observer: true,
                loopFillGroupWithBlank: false,
                observeParents: true,
                // centeredSlides: true,
                slidesPerView: this.props.slidePerview,
                slidesPerGroup: this.props.slidePerview,
                loop: false,
                breakpoints: {
                  // when window width is <= 499px
                  320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                      slidesPerGroup: 1
                  },

                   999: {
                      slidesPerView: this.props.slidePerview,
                      spaceBetween: 10,
                      slidesPerGroup: this.props.slidePerview,
                      
                    },
                  },
                // loopFillGroupWithBlank: true,
               
                pagination: {
                    el: this.props.isIndicatorRequired ? '.swiper-pagination' : '',
                    type: this.props.isIndicatorRequired ? 'bullets' : undefined,
                    // dynamicBullets: true,
                  },
                // Navigation arrows
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                  
                },
              });
            //   swiper.slideTo(0, 1, true);
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CarouselViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CarouselCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/carousel/carouselcomponent.tsx